/**
 * Country-total trend chart of ONE tracker (Voluum, Binom or Tres Commas): pick a metric, see this
 * country's total for it over time (Day/Week/Month), Range A overlaid vs Range B. Reuses
 * the dashboard compare chart panel + metric registry (state in useTrackerTrendChart).
 * For Media Devoted | Created By Ciro Autiero
 */

import { trackerLabel } from '@trafficpulse/shared';

import { CompareChartPanel } from '@/features/dashboard/compare/components/chart/CompareChartPanel';
import { formatRangeShort } from '@/features/dashboard/compare/state/comparePresets';

import { useTrackerTrendChart, type TrackerTrendChartProps } from './useTrackerTrendChart';

export function TrackerTrendChart(props: TrackerTrendChartProps) {
  const { series, ...chart } = useTrackerTrendChart(props);
  return (
    <div className="rounded-lg border border-border bg-card p-3">
      <div className="mb-2 text-sm font-medium text-foreground">
        Trend · {trackerLabel(props.provider)} totals (this country)
      </div>
      <CompareChartPanel
        {...chart}
        aligned={series.aligned}
        isLoading={series.isLoading}
        isError={series.isError}
        hasData={series.hasData}
        currency={series.currency}
        labelA={formatRangeShort(props.rangeA)}
        labelB={formatRangeShort(props.rangeB)}
        onRetry={series.refetch}
      />
    </div>
  );
}

export default TrackerTrendChart;
